import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../types/index";
import {handleUnauthorizedAccess} from "../../util/utility";

export function updateBroadcast(token, api_token, broadcast_id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcast/${broadcast_id}?api_token=${api_token}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.UPDATE_BROADCAST_REQUEST, types.UPDATE_BROADCAST_RECEIVE, {
                type: types.UPDATE_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUpdateBroadcast = () => ({
    type: types.RESET_UPDATE_BROADCAST,
    payload: null
});